import { application } from "./application"

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)